import React, { useMemo } from "react";
import PropTypes from "prop-types";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

import { TENSES } from "./data.js";

function TenseSelect({ onAdd, tenses }) {
  const [tensesChoices, tensesLabels] = useMemo(() => {
    const tenses = TENSES.reduce(
      (t, mode) =>
        mode.tenses.reduce(
          (res, tense) =>
            Object.assign(res, { [mode.id + "-" + tense.id]: mode.title + " " + tense.title }),
          t
        ),
      {}
    );

    return [Object.keys(tenses), tenses];
  }, []);
  const [tenseInput, setTenseInput] = React.useState("");

  return (
    <Autocomplete
      disableClearable
      clearOnBlur
      //disableCloseOnSelect
      selectOnFocus
      id="verb-search"
      value={""}
      onChange={(event, newValue) => {
        onAdd(newValue);
        setTenseInput("");
      }}
      inputValue={tenseInput}
      options={tensesChoices}
      getOptionLabel={(v) => tensesLabels[v]}
      getOptionDisabled={(v) => tenses.includes(v)}
      loadingText="Recherche..."
      noOptionsText={
        tenseInput ? "Pas de résultat." : "Saisissez quelques caractères pour rechercher un temps."
      }
      fullWidth
      sx={{ mt: 1 }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Rechercher/sélectionner un temps"
          InputProps={{
            ...params.InputProps,
            endAdornment: <React.Fragment>{params.InputProps.endAdornment}</React.Fragment>,
          }}
        />
      )}
    />
  );
}

TenseSelect.propTypes = {
  onAdd: PropTypes.func.isRequired,
  tenses: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default TenseSelect;
